module.exports = __webpack_public_path__ + "img/pds_config_1.355bed50.svg";